import { render, staticRenderFns } from "./ListComponents.vue?vue&type=template&id=716796c2&"
import script from "./ListComponents.vue?vue&type=script&lang=js&"
export * from "./ListComponents.vue?vue&type=script&lang=js&"
import style0 from "./ListComponents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports